var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"qcportal-kit-topnav","tabindex":"-1"}},[_c('div',{staticClass:"plat-nav plat-nav-wrap plat-nav-air-sub",attrs:{"role":"navigation","id":"navigationBar"}},[_c('Detail',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDetail),expression:"showDetail"}]})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }